var useUser;
var useApplicationPreferences;
var finishSceneLoad;
var logger;
var trackPageView;
var trackAction;
var getApolloClient;
var AsyncApolloProvider;
var settings;
var showErrorPage;
var errorPageComponents;
var handleUnauthorised;
var apm;
var logTimeToRender;
var useCapabilities;
var setPageMetadata;
var usePageMetadata;
var useSalesForceSendData;
var useSalesForceSubscriptionStatus;
var init = function (piralApi) {
    useUser = piralApi.useUser;
    useApplicationPreferences = piralApi.useApplicationPreferences;
    finishSceneLoad = piralApi.finishSceneLoad;
    logger = piralApi.logger;
    trackPageView = piralApi.trackPageView;
    trackAction = piralApi.trackAction;
    getApolloClient = piralApi.getApolloClient;
    AsyncApolloProvider = piralApi.AsyncApolloProvider;
    settings = piralApi.settings;
    showErrorPage = piralApi.showErrorPage;
    errorPageComponents = piralApi.errorPageComponents;
    handleUnauthorised = piralApi.handleUnauthorised;
    logTimeToRender = piralApi.logTimeToRender;
    useCapabilities = piralApi.useCapabilities;
    setPageMetadata = piralApi.setPageMetadata;
    usePageMetadata = piralApi.usePageMetadata;
    useSalesForceSendData = piralApi.useSalesForceSendData;
    useSalesForceSubscriptionStatus = piralApi.useSalesForceSubscriptionStatus;
    // @ts-ignore - awaiting publish
    apm = piralApi.apm;
};

export { AsyncApolloProvider, apm, errorPageComponents, finishSceneLoad, getApolloClient, handleUnauthorised, init, logTimeToRender, logger, setPageMetadata, settings, showErrorPage, trackAction, trackPageView, useApplicationPreferences, useCapabilities, usePageMetadata, useSalesForceSendData, useSalesForceSubscriptionStatus, useUser };
